module.exports = __webpack_public_path__ + "static/img/weiji.cfa3fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weiji.png
// module id = lSZh
// module chunks = 1